import { EyeOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Select, Space, Table, Tag, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePagination } from "@/shared/hooks/usePagination";
import { eventService } from "../services/event.service";

const { Title } = Typography;

const eventTypeLabels: Record<string, { label: string; color: string }> = {
	wedding: { label: "To'y", color: "red" },
	celebration: { label: "Bayram", color: "green" },
	conference: { label: "Anjuman", color: "blue" },
	other: { label: "Boshqa", color: "default" },
};

export function EventsPage() {
	const navigate = useNavigate();
	const { page, pageSize, onChange } = usePagination();
	const [eventType, setEventType] = useState<string | undefined>();

	const { data, isLoading } = useQuery({
		queryKey: ["events", { page, per_page: pageSize, event_type: eventType }],
		queryFn: () => eventService.list({ page, per_page: pageSize, event_type: eventType }),
	});

	const events = data?.data?.events || [];
	const pagination = data?.data?.pagination;

	const columns = [
		{ title: "ID", dataIndex: "id", width: 60 },
		{ title: "To'yxona", key: "hall", render: (_: unknown, r: Record<string, unknown>) => (r.wedding_hall as { name: string } | null)?.name || "—" },
		{
			title: "Turi", dataIndex: "event_type",
			render: (v: string) => { const t = eventTypeLabels[v]; return <Tag color={t?.color}>{t?.label || v}</Tag>; },
		},
		{ title: "Boshlanish", dataIndex: "started_at" },
		{ title: "Tugash", dataIndex: "ended_at", render: (v: string) => v || <Tag color="green">Davom etmoqda</Tag> },
		{ title: "Pik (odam)", dataIndex: "peak_count" },
		{ title: "O'rtacha", dataIndex: "avg_count" },
		{ title: "Sanatkorlar", dataIndex: "artist_count" },
		{
			title: "", width: 60,
			render: (_: unknown, r: { id: number }) => (
				<Button size="small" icon={<EyeOutlined />} onClick={() => navigate(`/events/${r.id}`)} />
			),
		},
	];

	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<Title level={3} className="!mb-0">Tadbirlar</Title>
				<Space>
					<Select placeholder="Turi" allowClear style={{ width: 150 }} value={eventType} onChange={setEventType}
						options={Object.entries(eventTypeLabels).map(([k, v]) => ({ value: k, label: v.label }))} />
				</Space>
			</div>
			<Table columns={columns} dataSource={events} rowKey="id" loading={isLoading}
				pagination={{ current: pagination?.current_page, pageSize: pagination?.per_page, total: pagination?.total_items, onChange, showSizeChanger: true }} />
		</div>
	);
}
